const KEY = "mma_attribution";

export const captureAttribution = () => {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search);
    const attr = {
      landing_page: window.location.pathname + window.location.search,
      referrer: document.referrer || null,
      utm_source: p.get("utm_source"),
      utm_medium: p.get("utm_medium"),
      utm_campaign: p.get("utm_campaign"),
      utm_content: p.get("utm_content"),
      utm_term: p.get("utm_term"),
      gclid: p.get("gclid"),
      gbraid: p.get("gbraid"),
      wbraid: p.get("wbraid"),
      fbclid: p.get("fbclid"),
      campaign_id: p.get("campaign_id"),
      adgroup_id: p.get("adgroup_id"),
      matchtype: p.get("matchtype"),
      device: p.get("device"),
    };
    sessionStorage.setItem(KEY, JSON.stringify(attr));
  } catch {}
};

export const getAttribution = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || { landing_page: window.location.pathname };
  } catch {
    return {};
  }
};

export const newSubmissionId = () =>
  crypto.randomUUID ? crypto.randomUUID() : `sub-${Date.now()}-${Math.random().toString(36).slice(2)}`;
